<mar-analysis-card
	[icon]="icon()"
	[label]="label()"
	[types]="types()"
	(typeChange)="onTypeChange($event)"
>
	<div class="flex-1 h-full flex flex-col gap-6">
		@if (legend().length) {
			<div
				class="flex flex-row gap-8 w-full items-center p-2 justify-center flex-0"
			>
				@for (label of legend(); track $index) {
					<div class="flex items-center gap-2">
						<div
							[class]="
								'rounded-full size-4 border-2 ' +
								colorIndex[$index]
							"
						></div>
						<p class="font-semibold">{{ label | transloco }}</p>
					</div>
				}
			</div>
		}

		<div class="flex flex-col gap-3 flex-1">
			@for (value of displayData(); track value) {
				<div class="flex items-center flex-row gap-4">
					<div class="w-12 flex-0">
						<p class="text-xs font-semibold">
							{{ value.label | transloco }}
						</p>
					</div>

					<div class="flex flex-1 flex-row gap-1.5 h-10 w-full">
						@for (data of value.data; track $index) {
							@if (
								type() === 'percent'
									? data.percent
									: data.value;
								as display
							) {
								<div
									[class]="
										'h-full flex items-center justify-center min-w-10 hover:scale-x-[1.03] hover:scale-y-[1.03] transition-all duration-300 border-2 ' +
										colorIndex[$index]
									"
									[style.width]="data.percent"
									[class.rounded-l-md]="$first"
									[class.rounded-r-md]="$last"
									[tuiHint]="display"
								>
									<p
										class="whitespace-pre-wrap text-xxs line-clamp-1 font-semibold"
									>
										{{ display }}
									</p>
								</div>
							}
						}
					</div>
				</div>

				@if (!$last) {
					<div class="flex items-center flex-row gap-4">
						<div class="w-12 flex-0"></div>
						<div class="flex-1 mar-divider"></div>
					</div>
				}
			}
		</div>
	</div>
</mar-analysis-card>
